var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('package-card',{staticClass:"package-card",attrs:{"content":_vm.content}},[_c('div',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('z-button',{staticClass:"z-button"},[_c('span',[_vm._v("Descargar Plantilla")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }